

<template>
  <div>
    <!--    Breadcrumb Section Component-->
    <breadcrumb :breadcrumb="breadcrumb"/>
    <!--    Cart Section Component-->
    <cart-page-area/>
  </div>
</template>
<script>
import Breadcrumb from "../components/Breadcrumb";
import CartPageArea from "../components/products/CartPageArea";

export default {
  name: 'Cart',
  components: {CartPageArea, Breadcrumb},
  data() {
    return {
      breadcrumb: {
        title: 'Cart',
        link: 'Cart'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Cart.vue